var render, staticRenderFns
import script from "./AddSection.vue?vue&type=script&lang=js&"
export * from "./AddSection.vue?vue&type=script&lang=js&"
import style0 from "./AddSection.vue?vue&type=style&index=0&id=52779cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52779cd8",
  null
  
)

export default component.exports